/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyApiModel } from './companyApiModel';


export interface EmployerApiModel { 
    id: number;
    tenantId: number;
    mainCompany: CompanyApiModel;
    guid: string;
    isActive: boolean;
}

